<template>
  <v-container fluid class="pa-2 pa-sm-4">
    <v-row justify="center" no-gutters>
      <!-- MINI Plan -->
      <v-col cols="12" sm="6" md="4" class="pa-2">
        <div class="plan-wrapper">
          <div
            class="plan-card"
            :class="{ 'plan-selected': choosenPlan === 2 }"
            @click="choosePlan(2)"
          >
            <div class="plan-header">
              <h3 class="plan-title">STARTER</h3>
              <div class="plan-price">
                <span class="price-amount">49€</span>
                <span class="price-period">/ month</span>
              </div>
            </div>
            <!--
              "Up to 500 products",
              "Up to 5 competitors",
              "3 updates per day",
              "Email alerts"
            -->

            <div class="plan-features">
              <ul class="features-list">
                <li class="feature-item">
                  <v-icon small color="success" class="mr-2">mdi-check</v-icon>
                  Up to 5 competitors!
                </li>
                <li class="feature-item">
                  <v-icon small color="success" class="mr-2">mdi-check</v-icon>
                  Up to 500 products
                </li>
                <li class="feature-item">
                  <v-icon small color="success" class="mr-2">mdi-check</v-icon>
                  3 updates per day
                </li>
                <li class="feature-item">
                  <v-icon small color="success" class="mr-2">mdi-check</v-icon>
                  Email alerts
                </li>
              </ul>
            </div>

            <div class="plan-footer">
              <v-btn
                :color="choosenPlan === 2 ? 'primary' : 'secondary'"
                :outlined="choosenPlan !== 2"
                block
                class="text-none"
                @click.stop="choosePlan(2)"
              >
                {{ choosenPlan === 2 ? 'Selected' : 'Choose Plan' }}
              </v-btn>
            </div>
          </div>
        </div>
      </v-col>

      <!--
        "Up to 2,500 products",
        "Up to 15 competitors",
        "6 updates per day",
        "Email & Slack alerts",
        "API access",
        "Priority support"
      -->
      <!-- PROFESSIONAL Plan -->
      <v-col cols="12" sm="6" md="4" class="pa-2">
        <div class="plan-wrapper">
          <div class="popular-badge" v-if="$vuetify.breakpoint.smAndUp">
            <span class="badge-text">PROFESSIONAL</span>
          </div>
          <div
            class="plan-card plan-popular"
            :class="{ 'plan-selected': choosenPlan === 1 }"
            @click="choosePlan(1)"
          >
            <div class="plan-header">
              <h3 class="plan-title">PROFESSIONAL</h3>
              <div class="plan-price">
                <span class="price-amount">99€</span>
                <span class="price-period">/ month</span>
              </div>
            </div>

            <div class="plan-features">
              <ul class="features-list">
                <li class="feature-item">
                  <v-icon small color="success" class="mr-2">mdi-check</v-icon>
                  Up to 2,500 products
                </li>
                <li class="feature-item">
                  <v-icon small color="success" class="mr-2">mdi-check</v-icon>
                  Up to 15 competitors
                </li>
                <li class="feature-item">
                  <v-icon small color="success" class="mr-2">mdi-check</v-icon>
                  6 updates per day
                </li>
                <li class="feature-item">
                  <v-icon small color="success" class="mr-2">mdi-check</v-icon>
                  Email & Slack alerts
                </li>
                <li class="feature-item">
                  <v-icon small color="success" class="mr-2">mdi-check</v-icon>
                  Api access
                </li>
                <li class="feature-item">
                  <v-icon small color="success" class="mr-2">mdi-check</v-icon>
                  Priority support
                </li>
              </ul>
            </div>

            <div class="plan-footer">
              <v-btn
                :color="choosenPlan === 1 ? 'primary' : 'secondary'"
                :outlined="choosenPlan !== 1"
                block
                class="text-none"
                @click.stop="choosePlan(1)"
              >
                {{ choosenPlan === 1 ? 'Selected' : 'Choose Plan' }}
              </v-btn>
            </div>
          </div>
        </div>
      </v-col>

      <!-- PREMIUM Plan -->
      <v-col cols="12" sm="6" md="4" class="pa-2">
        <div class="plan-wrapper">
          <div
            class="plan-card"
            :class="{ 'plan-selected': choosenPlan === 0 }"
            @click="choosePlan(0)"
          >
            <div class="plan-header">
              <h3 class="plan-title">BUSINESS</h3>
              <div class="plan-price">
                <span class="price-amount">199€</span>
                <span class="price-period">/ month</span>
              </div>
            </div>

            <!--
                "Up to 10,000 products",
                "Up to 50 competitors",
                "15 updates per day",
                "Email, Slack & Webhook alerts",
                "API access",
                "Dedicated account manager"
            -->
            <div class="plan-features">
              <ul class="features-list">
                <li class="feature-item">
                  <v-icon small color="success" class="mr-2">mdi-check</v-icon>
                  Up to 10,000 competitors
                </li>
                <li class="feature-item">
                  <v-icon small color="success" class="mr-2">mdi-check</v-icon>
                  Up to 50 competitors
                </li>
                <li class="feature-item">
                  <v-icon small color="success" class="mr-2">mdi-check</v-icon>
                  15 updates per day
                </li>
                <li class="feature-item">
                  <v-icon small color="success" class="mr-2">mdi-check</v-icon>
                  Email, Slack & Webhook alerts
                </li>
                <li class="feature-item">
                  <v-icon small color="success" class="mr-2">mdi-check</v-icon>
                  API access
                </li>
                <li class="feature-item">
                  <v-icon small color="success" class="mr-2">mdi-check</v-icon>
                  Dedicated account manager
                </li>
              </ul>
            </div>

            <div class="plan-footer">
              <v-btn
                :color="choosenPlan === 0 ? 'primary' : 'secondary'"
                :outlined="choosenPlan !== 0"
                block
                class="text-none"
                @click.stop="choosePlan(0)"
              >
                {{ choosenPlan === 0 ? 'Selected' : 'Choose Plan' }}
              </v-btn>
            </div>
          </div>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    name: 'plans',
    props: ['selected_plan', 'show'],
    data() {
      return {
        choosenPlan: 1, // Default to Professional plan
      }
    },
    methods: {
      choosePlan(num) {
        this.choosenPlan = num
        this.$emit('choosen-plan', this.choosenPlan)
      },
    },
    watch: {
      show: {
        handler() {
          if (this.selected_plan !== undefined) {
            this.choosePlan(this.selected_plan)
          }
        },
      },
    },
    mounted() {
      // Set initial plan if provided
      if (this.selected_plan !== undefined) {
        this.choosePlan(this.selected_plan)
      }
    },
  }
</script>

<style scoped lang="scss">
  .plan-wrapper {
    position: relative;
    height: 100%;
  }

  .popular-badge {
    position: absolute;
    top: -8px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 2;

    .badge-text {
      background: linear-gradient(45deg, #ff6b6b, #ee5a24);
      color: white;
      padding: 4px 16px;
      font-size: 12px;
      font-weight: bold;
      border-radius: 12px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
    }
  }

  .plan-card {
    height: 100%;
    min-height: 400px;
    display: flex;
    flex-direction: column;
    background: #ffffff;
    border: 2px solid #e0e0e0;
    border-radius: 12px;
    cursor: pointer;
    transition: all 0.3s ease;
    overflow: hidden;

    &:hover {
      transform: translateY(-4px);
      box-shadow: 0 8px 25px rgba(0, 0, 0, 0.12);
      border-color: #5bc0db;
    }

    &.plan-popular {
      border-color: #5bc0db;
      box-shadow: 0 4px 20px rgba(91, 192, 219, 0.2);
    }

    &.plan-selected {
      border-color: #5bc0db;
      border-width: 3px;
      box-shadow: 0 8px 30px rgba(91, 192, 219, 0.3);

      .plan-header {
        background: linear-gradient(135deg, #5bc0db, #4a9eff);
        color: white;

        .plan-title {
          color: white;
        }

        .price-amount {
          color: white;
        }

        .price-period {
          color: rgba(255, 255, 255, 0.8);
        }
      }
    }
  }

  .plan-header {
    padding: 24px 20px;
    text-align: center;
    background: #f8f9fa;
    transition: all 0.3s ease;

    .plan-title {
      font-size: 1.5rem;
      font-weight: bold;
      color: #f96654;
      margin: 0 0 16px 0;

      @media (max-width: 600px) {
        font-size: 1.25rem;
      }
    }

    .plan-price {
      .price-amount {
        font-size: 2rem;
        font-weight: bold;
        color: #2c3e50;

        @media (max-width: 600px) {
          font-size: 1.75rem;
        }
      }

      .price-period {
        font-size: 1rem;
        color: #7f8c8d;
        margin-left: 4px;

        @media (max-width: 600px) {
          font-size: 0.875rem;
        }
      }
    }
  }

  .plan-features {
    flex: 1;
    padding: 20px;

    .features-list {
      list-style: none;
      padding: 0;
      margin: 0;

      .feature-item {
        display: flex;
        align-items: center;
        padding: 8px 0;
        font-size: 0.95rem;
        color: #2c3e50;
        border-bottom: 1px solid #f0f0f0;

        &:last-child {
          border-bottom: none;
        }

        @media (max-width: 600px) {
          font-size: 0.875rem;
          padding: 6px 0;
        }
      }
    }
  }

  .plan-footer {
    padding: 20px;
    margin-top: auto;
  }

  // Mobile specific adjustments
  @media (max-width: 960px) {
    .plan-card {
      min-height: 350px;
    }
  }

  @media (max-width: 600px) {
    .plan-card {
      min-height: 320px;
    }

    .plan-header {
      padding: 20px 16px;
    }

    .plan-features {
      padding: 16px;
    }

    .plan-footer {
      padding: 16px;
    }
  }
</style>
